import { render, staticRenderFns } from "./LandfillManagementPage.vue?vue&type=template&id=282ef008&scoped=true"
import script from "./LandfillManagementPage.vue?vue&type=script&lang=js"
export * from "./LandfillManagementPage.vue?vue&type=script&lang=js"
import style0 from "./LandfillManagementPage.vue?vue&type=style&index=0&id=282ef008&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282ef008",
  null
  
)

export default component.exports